export default "__VITE_ASSET__c2f1d4db__"